import { UseFormMethods } from 'react-hook-form';
import { NetworkingFormData } from '../index';

export const dhcpFieldOptions = {
  shouldDirty: true,
  shouldValidate: true,
};

export async function applyDhcpFormChange(
  assignDhcp: boolean | string,
  currentIpAddress: string | undefined,
  setValue: UseFormMethods<NetworkingFormData>['setValue'],
  trigger: UseFormMethods<NetworkingFormData>['trigger'],
): Promise<void> {
  setValue('assignDhcp', assignDhcp, dhcpFieldOptions);
  setValue('ipAddress', currentIpAddress ?? '', dhcpFieldOptions);
  await trigger('ipAddress');
}
